import React__default, { createElement, Fragment, useEffect, useState, useRef } from 'react';
import styled, { css, withTheme } from 'styled-components';
import { space, maxWidth, fontSize, color, fontWeight, lineHeight, textAlign, width, fontStyle, border, minWidth, height, shadow, borderColor } from 'styled-system';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Box, Flex } from 'reflexbox/styled-components';
import ReactDOM from 'react-dom';
import { times } from 'ramda';
import { isFragment } from 'react-is';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var idPostfix = '-id';
var normalizeInputNameForE2E = function normalizeInputNameForE2E(name) {
  // @ts-ignore
  if (name === undefined && window.config.env !== 'production') {
    // tslint:disable-next-line no-console
    console.warn("name must be not equal undefined normalizeInputNameForE2E: ".concat(name));
  }

  return name && name.toString().trim().split('.').filter(function (i) {
    return !i.includes(idPostfix);
  }).join('_');
};

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    text-decoration: none;\n    white-space: normal !important;\n    font-family: 'Montserrat', sans-serif, Arial, Helvetica;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    text-decoration: none;\n    white-space: normal !important;\n    font-family: 'Montserrat', sans-serif, Arial, Helvetica;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var TypeExtended = styled(Box)(_templateObject(), space, maxWidth, fontSize, color, fontWeight, lineHeight, textAlign, width, fontStyle, border, function (_ref) {
  var visuallyHidden = _ref.visuallyHidden;
  return visuallyHidden && "   position: absolute;\n            left: -10000px;\n            top: auto;\n            width: 1px;\n            height: 1px;\n            overflow: hidden;\n        ";
});
var Type = styled.div(_templateObject2(), space, maxWidth, fontSize, color, fontWeight, lineHeight, textAlign, width, fontStyle, border);

var Text = function Text(_a) {
  var props = __rest(_a, []);

  return /*#__PURE__*/createElement(Box, props);
};

var checkIfTxIncludesTags = function checkIfTxIncludesTags(tx) {
  return !!tx && /<[a-z][\s\S]*>/i.test(tx.toString());
};
/**
 * We've split the Typograph component into two versions:
 * v1: the old version, which just outputs a div & a span
 * v2: a new version that allows you to customize the HTML tags of the outer and inner element using the `as` prop
 * Where possible, please pass `as` or `childAs` with the appropriate text tag (p, h1-h6,...) to improve the semantics of the site.
 * Ideally, we would only have v2, but there was an instance where v2 caused a visual bug, and so we don't want to risk having a bunch of bugs that we don't know about.
 * Hopefully, with time, we will be able to deprecate v1.
 *
 */

var Typograph = function Typograph(_a) {
  var tx = _a.tx,
      text = _a.text,
      defaultTx = _a.defaultTx,
      values = _a.values,
      children = _a.children,
      setInnerHtml = _a.setInnerHtml,
      childAs = _a.childAs,
      rest = __rest(_a, ["tx", "text", "defaultTx", "values", "children", "setInnerHtml", "childAs"]);

  if (childAs || rest.as || rest.visuallyHidden) {
    return /*#__PURE__*/createElement(TypeExtended, rest, tx ? /*#__PURE__*/createElement(FormattedMessage, {
      id: tx,
      values: values,
      defaultMessage: defaultTx
    }, function (txt) {
      return setInnerHtml && checkIfTxIncludesTags(txt) ? /*#__PURE__*/createElement(Text, {
        as: childAs ? childAs : 'span',
        id: normalizeInputNameForE2E(tx || text || 'no-translation-id'),
        "data-test-id": normalizeInputNameForE2E(tx || 'no-translation-id'),
        dangerouslySetInnerHTML: {
          __html: txt
        }
      }) : /*#__PURE__*/createElement(Text, {
        as: childAs ? childAs : 'span',
        id: normalizeInputNameForE2E(tx || text || 'no-translation-id'),
        "data-test-id": normalizeInputNameForE2E(tx || 'no-translation-id')
      }, txt);
    }) : /*#__PURE__*/createElement(Fragment, null, children));
  }

  return /*#__PURE__*/createElement(Type, rest, tx ? /*#__PURE__*/createElement(FormattedMessage, {
    id: tx,
    values: values,
    defaultMessage: defaultTx
  }, function (txt) {
    return setInnerHtml && checkIfTxIncludesTags(txt) ? /*#__PURE__*/createElement("span", {
      id: normalizeInputNameForE2E(tx || text || 'no-translation-id'),
      "data-test-id": normalizeInputNameForE2E(tx || 'no-translation-id'),
      dangerouslySetInnerHTML: {
        __html: sanitize(txt)
      }
    }) : /*#__PURE__*/createElement("span", {
      id: normalizeInputNameForE2E(tx || text || 'no-translation-id'),
      "data-test-id": normalizeInputNameForE2E(tx || 'no-translation-id')
    }, txt);
  }) : /*#__PURE__*/createElement(Fragment, null, children));
};

var sanitize = function sanitize(txtContent) {
  var _a;

  var str = txtContent;
  var isString = typeof txtContent === 'string'; // make sure the text content is a string

  if (!isString) {
    str = "".concat(txtContent);
  } // @ts-expect-error - window.DOMPurify is cdn from cloudflare
  // see `frontend/public/index.html` for more info
  // https://cdnjs.cloudflare.com/ajax/libs/dompurify/3.1.5/purify.min.js
  //
  // I tryied to insall it via npm but it didn't work
  // the code base is too old and cant be updated
  // so I'm using the cdn


  if (typeof window === 'undefined' || !window.DOMPurify) {
    // may land here when testing locally
    return str;
  } // @ts-expect-error - window.DOMPurify is cdn from cloudflare


  return (_a = window.DOMPurify) === null || _a === void 0 ? void 0 : _a.sanitize(str, {
    ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'abbr', 'span', 'br'],
    ALLOWED_ATTR: ['style']
  });
};

var CheckCircle = function CheckCircle(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '30' : _ref$height,
      selected = _ref.selected;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "30",
    height: height,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, selected ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15",
    fill: "#3D66B0"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.5 10L14 19.5L10 16",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round"
  })) : /*#__PURE__*/React__default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "14.5",
    stroke: "#9B9B9B"
  }));
};

var RightArrow = function RightArrow(_ref) {
  var _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === void 0 ? '#fff' : _ref$fillColor,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 11 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 10 : _ref$height;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: width,
    height: height,
    viewBox: "0 0 9 8"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "njcga",
    d: "M513.607 434.5a.5.5 0 0 1 .5.5v4.788l1.146-1.146a.5.5 0 0 1 .707.707l-1.95 1.95a.5.5 0 0 1-.807 0l-1.95-1.95a.5.5 0 1 1 .707-.707l1.147 1.146V435a.5.5 0 0 1 .5-.5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "njcgc",
    d: "M509.607 442v-8h8v8z"
  }), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "njcgb"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#njcga"
  }))), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(-509 -434)"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "rotate(-90 514 438)"
  }, /*#__PURE__*/React__default.createElement("use", {
    fill: fillColor,
    xlinkHref: "#njcga"
  })))));
};

function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
}

/* global window */

var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var result = symbolObservablePonyfill(root);

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    outline: none;\n    box-shadow: none;\n    border: 1px solid;\n    border-radius: ", ";\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: ", "px;\n    padding-right: ", "px;\n    transition: all 0.15s;\n\n    min-width: 200px;\n    max-width: 400px;\n    > div span {\n        ", "\n    }\n\n    > div {\n        position: relative;\n        > div {\n            display: block;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            right: -16px;\n            height: 12px;\n            width: 12px;\n        }\n    }\n\n    :focus,\n    :active,\n    :hover {\n        > div > div {\n            opacity: 1;\n            transform: translateX(0px);\n        }\n    }\n    :disabled {\n        > div > div {\n            display: none;\n        }\n    }\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    transition: all 0.355s cubic-bezier(0.02, 0.01, 0.47, 1);\n    opacity: 0;\n    width: 0;\n    display: flex;\n    transform: translateX(-10px);\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    ::after {\n        ", ";\n        content: attr(title);\n        display: block;\n        height: 0;\n        overflow: hidden;\n        visibility: hidden;\n    }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n            border-color: ", ";\n            background-color: ", ";\n        "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n            :focus,\n            :active,\n            :hover {\n                ", ";\n            }\n        "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n            > *:first-child {\n                margin-right: 1rem;\n            }\n            justify-content: left;\n            text-align: left;\n            background: transparent;\n            min-height: 50px;\n            border: ", ";\n            border-radius: 10px;\n            color: black;\n\n            :hover,\n            :active,\n            :focus {\n                border: 3px solid #3d66b0;\n                background: transparent;\n                color: black;\n            }\n        "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n            background: transparent;\n            border-radius: 0px;\n            border-radius: 10px;\n            color: black;\n            min-width: 150px;\n            border-color: #9b9b9b;\n            :hover,\n            :active,\n            :focus {\n                color: black;\n                background: transparent;\n                border: 2px black solid;\n            }\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n            :focus > span,\n            :active > span,\n            :hover > span {\n                opacity: 1;\n                width: 16px;\n                transform: translateX(6px);\n            }\n        "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        :disabled {\n            cursor: default;\n            color: ", ";\n            border-color: ", ";\n            background-color: ", ";\n            :focus,\n            :active,\n            :hover {\n                ", ";\n                color: ", ";\n                border-color: ", ";\n                background-color: ", ";\n            }\n        }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n            border-width: 1px;\n            border-color: ", ";\n            > div {\n                color: #b0b0b0;\n            }\n            :focus,\n            :active,\n            :hover {\n                border-color: ", ";\n                border-width: 1px;\n                > div {\n                    color: ", ";\n                }\n            }\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n            color: ", ";\n            border-width: 2px;\n            > div {\n                color: ", ";\n                font-weight: ", ";\n            }\n            &:focus,\n            &:active,\n            &:hover {\n                ", ";\n                background-color: ", ";\n                color: ", ";\n                border-width: 2px;\n                font-weight: ", ";\n                > div {\n                    color: ", ";\n                    font-weight: ", ";\n                }\n            }\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n            border-color: ", ";\n            background-color: ", ";\n            color: ", ";\n            :focus,\n            :active,\n            :hover {\n                border-color: ", ";\n                background-color: ", ";\n                color: ", ";\n            }\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    font-size: ", ";\n    color: ", ";\n    border-color: ", ";\n    background-color: ", ";\n\n    :focus,\n    :active,\n    :hover {\n        color: ", ";\n        border-color: ", ";\n        background-color: ", ";\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n                min-height: 50px;\n                ", ";\n            "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n                min-height: 40px;\n                ", ";\n            "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n                min-height: 30px;\n                font-size: ", ";\n            "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var mapStylesToPresets = function mapStylesToPresets(_ref) {
  var preset = _ref.preset,
      theme = _ref.theme;

  switch (preset) {
    case 'TINY':
      return css(_templateObject$1(), theme.fontSizes[1]);

    case 'SMALL':
      return css(_templateObject2$1(), width);

    default:
      return css(_templateObject3(), width);
  }
};

var defaultStyles = function defaultStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject4(), theme.fonts.Montserrat400, theme.fontSizes[2], theme.button["default"].color, theme.button["default"].borderColor, theme.button["default"].background, theme.button.hover.color, theme.button.hover.borderColor, theme.button.hover.background);
};

var tertiaryStyles = function tertiaryStyles(_ref3) {
  var theme = _ref3.theme,
      tertiary = _ref3.tertiary,
      groupButton = _ref3.groupButton;

  if (tertiary) {
    return css(_templateObject5(), theme.brand.tertiary, !groupButton ? theme.brand.tertiary : undefined, !groupButton ? theme.brand.secondary : undefined, theme.brand.tertiary, theme.brand.tertiary, theme.brand.secondary);
  }
};

var outlineStyles = function outlineStyles(_ref4) {
  var theme = _ref4.theme,
      outline = _ref4.outline,
      tertiary = _ref4.tertiary,
      fontWeight = _ref4.fontWeight;

  if (outline) {
    return css(_templateObject6(), theme.fonts.Montserrat400, theme.input["default"].background, tertiary ? theme.brand.tertiary : theme.brand.primary, tertiary ? theme.brand.tertiary : theme.brand.primary, String(fontWeight || 600), theme.fonts.Montserrat700, theme.input["default"].background, tertiary ? theme.brand.tertiary : theme.brand.primary, String(fontWeight || 600), tertiary ? theme.brand.tertiary : theme.brand.primary, String(fontWeight || 600));
  }
};

var mutedStyles = function mutedStyles(_ref5) {
  var theme = _ref5.theme,
      muted = _ref5.muted;

  if (muted) {
    return css(_templateObject7(), theme.borderColor["default"], theme.brand.tertiary, theme.brand.tertiary);
  }
};

var disabledStyles = function disabledStyles(_ref6) {
  var theme = _ref6.theme;
  return css(_templateObject8(), theme.button.disabled.color, theme.button.disabled.borderColor, theme.button.disabled.background, theme.fonts.Montserrat400, theme.button.disabled.color, theme.button.disabled.borderColor, theme.button.disabled.background);
};

var arrowStyles = function arrowStyles(_ref7) {
  var disabled = _ref7.disabled,
      hideArrow = _ref7.hideArrow;

  if (!disabled && !hideArrow) {
    // Find a better way to do this.
    return css(_templateObject9());
  }
};

var CheckCircleStyles = function CheckCircleStyles(_ref8) {
  var showCheckCircle = _ref8.showCheckCircle,
      groupButton = _ref8.groupButton,
      squareBorder = _ref8.squareBorder;

  if (squareBorder) {
    return css(_templateObject10());
  }

  if (showCheckCircle) return css(_templateObject11(), !groupButton ? '3px solid #3d66b0' : '1px solid #9b9b9b');
};
/**
 * Todo:
 * Refactor. Make the default button the default option
 * and change to group or submit button only when
 * supplied the appropriate props.
 */


var additionalStyles = function additionalStyles(_ref9) {
  var theme = _ref9.theme,
      groupButton = _ref9.groupButton;

  if (groupButton) {
    // Default Button
    return css(_templateObject12(), theme.fonts.Montserrat700);
  } else {
    // Submit Button
    return css(_templateObject13(), theme.fonts.Montserrat700, theme.button.hover.color, theme.button.hover.borderColor, theme.button.hover.background);
  }
};
/**
 * This is a CSS trick to make sure that
 * any text that will have a hover/active
 * effect that makes it bold, will have
 * from the start, accounted for the final
 * width of the text and accordingly take
 * that space in the element it is placed within.
 *
 * Without this, the problem you would run into
 * is that on hover, the button (in this case)
 * would get slightly bigger in width and shrink
 * when the button is no longer hover/active.
 */


var boldLengthStyles = function boldLengthStyles(_ref10) {
  var theme = _ref10.theme;
  return css(_templateObject14(), theme.fonts.Montserrat700);
};

var StyledArrow = styled.div(_templateObject15());
var StyledButton = styled.button(_templateObject16(), function (props) {
  return props.theme.radii.full;
}, function (props) {
  return props.theme.space[3];
}, function (props) {
  return props.theme.space[3];
}, boldLengthStyles, defaultStyles, additionalStyles, tertiaryStyles, CheckCircleStyles, outlineStyles, arrowStyles, disabledStyles, mapStylesToPresets, mutedStyles, fontSize, space, width, minWidth, maxWidth);

var ButtonView = function ButtonView(_a) {
  var label = _a.label,
      children = _a.children,
      name = _a.name,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      hideArrow = _a.hideArrow,
      onClick = _a.onClick,
      input = _a.input,
      meta = _a.meta,
      _a$values = _a.values,
      values = _a$values === void 0 ? {} : _a$values,
      groupButton = _a.groupButton,
      _a$width = _a.width,
      width = _a$width === void 0 ? ['100%'] : _a$width,
      type = _a.type,
      theme = _a.theme,
      intl = _a.intl,
      showCheckCircle = _a.showCheckCircle,
      outline = _a.outline,
      props = __rest(_a, ["label", "children", "name", "disabled", "hideArrow", "onClick", "input", "meta", "values", "groupButton", "width", "type", "theme", "intl", "showCheckCircle", "outline"]);

  var id = normalizeInputNameForE2E(props.id || label || 'no-translation-id');
  return /*#__PURE__*/React__default.createElement(StyledButton, _extends({
    width: width,
    "data-test-id": name,
    disabled: disabled,
    hideArrow: hideArrow,
    onClick: onClick,
    input: input,
    meta: meta,
    type: type,
    groupButton: groupButton,
    mt: [2],
    showCheckCircle: showCheckCircle,
    outline: outline
  }, props), showCheckCircle && /*#__PURE__*/React__default.createElement(CheckCircle, {
    selected: !groupButton
  }), children, label && /*#__PURE__*/React__default.createElement(Typograph, null, /*#__PURE__*/React__default.createElement("span", {
    "data-test-id": id,
    id: id,
    title: intl.formatMessage({
      id: label
    }, values)
  }, intl.formatMessage({
    id: label
  }, values)), !disabled && !hideArrow && /*#__PURE__*/React__default.createElement(StyledArrow, null, /*#__PURE__*/React__default.createElement(RightArrow, {
    fillColor: "currentColor"
  }))));
};

var Button = compose(withTheme, injectIntl)(ButtonView);

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    border: none;\n    background: none;\n    padding: 0;\n    margin: 0;\n    font-size: inherit;\n    font-family: inherit;\n    font-family: ", ";\n    &:focus-visible {\n        outline: 5px auto Highlight;\n        outline: 5px auto -webkit-focus-ring-color;\n    }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var Button$1 = styled.button(_templateObject$2(), function (props) {
  return props.theme.fontFamily;
});
var UnstyledButton = function UnstyledButton(_a) {
  var accessibleLabel = _a.accessibleLabel,
      children = _a.children,
      props = __rest(_a, ["accessibleLabel", "children"]);

  return /*#__PURE__*/React__default.createElement(Button$1, props, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, accessibleLabel && /*#__PURE__*/React__default.createElement(Typograph, {
    visuallyHidden: true,
    tx: accessibleLabel
  }), children));
};

var SubmitButtonView = function SubmitButtonView(_a) {
  var _a$invalid = _a.invalid,
      invalid = _a$invalid === void 0 ? false : _a$invalid,
      submitting = _a.submitting,
      children = _a.children,
      _a$width = _a.width,
      width = _a$width === void 0 ? ['100%', 'auto'] : _a$width,
      _a$id = _a.id,
      id = _a$id === void 0 ? 'nextStep' : _a$id,
      theme = _a.theme,
      props = __rest(_a, ["invalid", "submitting", "children", "width", "id", "theme"]);

  return /*#__PURE__*/React__default.createElement(Button, _extends({
    type: "submit",
    disabled: invalid || submitting,
    width: width || theme.setWidths,
    "data-test-id": id
  }, props), children);
};

SubmitButtonView.defaultProps = {
  mt: [3]
};
var SubmitButton = withTheme(SubmitButtonView);

var GroupButtonView = function GroupButtonView(_a) {
  var _a$invalid = _a.invalid,
      invalid = _a$invalid === void 0 ? false : _a$invalid,
      submitting = _a.submitting,
      children = _a.children,
      width = _a.width,
      _a$id = _a.id,
      id = _a$id === void 0 ? 'nextStep' : _a$id,
      theme = _a.theme,
      props = __rest(_a, ["invalid", "submitting", "children", "width", "id", "theme"]);

  return /*#__PURE__*/React__default.createElement(Button, _extends({
    type: "submit",
    groupButton: true,
    disabled: invalid || submitting,
    hideArrow: true,
    width: width || theme.setWidths,
    "data-test-id": id
  }, props), children);
};
var GroupButton = withTheme(GroupButtonView);

var RadioButtonCheckedView = function RadioButtonCheckedView(_ref) {
  var fillColor = _ref.fillColor,
      theme = _ref.theme;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "ie1ga",
    d: "M594 2562.5c0-6.904 5.596-12.5 12.5-12.5s12.5 5.596 12.5 12.5-5.596 12.5-12.5 12.5-12.5-5.596-12.5-12.5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "ie1gb",
    d: "M601.813 2562.5a4.688 4.688 0 1 1 9.375 0 4.688 4.688 0 0 1-9.375 0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "ie1gd",
    d: "M598.5 2570.5v-16h16v16z"
  }), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "ie1ge"
  }, /*#__PURE__*/React__default.createElement("use", {
    fill: "#fff",
    xlinkHref: "#ie1ga"
  })), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "ie1gc"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#ie1gb"
  }))), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(-594 -2550)"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#ie1gc)"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("use", {
    fill: fillColor || theme.brand.accent,
    xlinkHref: "#ie1gd"
  })))), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("use", {
    fill: "#fff",
    fillOpacity: "0",
    stroke: "#e8e8e8",
    strokeMiterlimit: "50",
    strokeWidth: "2",
    clipPath: "url(\"#ie1ge\")",
    xlinkHref: "#ie1ga"
  }))))));
};

var RadioButtonChecked = withTheme(RadioButtonCheckedView);

var RadioButtonView = function RadioButtonView(_ref) {
  var strokeColor = _ref.strokeColor,
      theme = _ref.theme;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "go0ba",
    d: "M594 2595.5c0-6.904 5.596-12.5 12.5-12.5s12.5 5.596 12.5 12.5-5.596 12.5-12.5 12.5-12.5-5.596-12.5-12.5z"
  }), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "go0bc"
  }, /*#__PURE__*/React__default.createElement("use", {
    fill: "#fff",
    xlinkHref: "#go0ba"
  })), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "go0bb"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#go0ba"
  }))), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(-594 -2583)"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("use", {
    fill: "#f5f5fa",
    xlinkHref: "#go0ba"
  })), /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#go0bb)"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("use", {
    fill: "#fff",
    fillOpacity: "0",
    stroke: strokeColor || theme.borderColor["default"],
    strokeMiterlimit: "50",
    strokeWidth: "2",
    clipPath: "url(\"#go0bc\")",
    xlinkHref: "#go0ba"
  }))))));
};

var RadioButtonIcon = withTheme(RadioButtonView);

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    padding: 4px 0px 0px 10px;\n    color: ", ";\n    cursor: pointer;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n    border-color: blue;\n    display: flex;\n    background: none;\n    border: none;\n    outline: none;\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
/* prettier-ignore */

var StyledRadioButton = styled.button(_templateObject$3(), space, width, maxWidth);
var StyledLabelRadio = styled.span(_templateObject2$2(), function (props) {
  return props.theme.fontSizes[2];
}, function (props) {
  return props.theme.colors.tundora;
});

var RadioButtonView$1 = function RadioButtonView(_a) {
  var label = _a.label,
      color = _a.color,
      _a$fontSize = _a.fontSize,
      _a$fontWeight = _a.fontWeight,
      active = _a.active,
      name = _a.name,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      hideArrow = _a.hideArrow,
      onClick = _a.onClick,
      input = _a.input,
      meta = _a.meta,
      _a$type = _a.type,
      type = _a$type === void 0 ? 'button' : _a$type,
      width = _a.width,
      children = _a.children,
      checkColor = _a.checkColor,
      borderColor = _a.borderColor,
      theme = _a.theme,
      props = __rest(_a, ["label", "color", "fontSize", "fontWeight", "active", "name", "disabled", "hideArrow", "onClick", "input", "meta", "type", "width", "children", "checkColor", "borderColor", "theme"]);

  return /*#__PURE__*/React__default.createElement(StyledRadioButton, _extends({
    width: width,
    "data-test-id": name,
    disabled: disabled,
    onClick: onClick,
    input: input,
    meta: meta,
    type: type,
    name: name
  }, props, {
    id: "btn-input-".concat(name)
  }), active ? /*#__PURE__*/React__default.createElement(RadioButtonChecked, {
    fillColor: checkColor || theme.brand.accent
  }) : /*#__PURE__*/React__default.createElement(RadioButtonIcon, {
    strokeColor: borderColor || theme.borderColor["default"]
  }), children && /*#__PURE__*/React__default.createElement(StyledLabelRadio, null, children));
};

var RadioButton = withTheme(RadioButtonView$1);

var DocumentUpload = function DocumentUpload(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 26 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 26 : _ref$height,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === void 0 ? 'currentColor' : _ref$fillColor;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: width,
    height: height,
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", {
    id: "Group-3",
    transform: "translate(4.000000, 2.000000)"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Shape-Copy-5",
    fill: fillColor,
    d: "M17.2,5.6l-4.9-4.9C11.8,0.3,11.2,0,10.5,0H3.9C1.7,0,0,1.7,0,3.8v15.3 C0,21.3,1.7,23,3.9,23h10.3c2.1,0,3.9-1.7,3.9-3.8V7.4C18,6.8,17.7,6.1,17.2,5.6z M11.6,1.8l4.6,4.6h-3.3c-0.7,0-1.3-0.6-1.3-1.3 V1.8z M16.7,19.2c0,1.4-1.2,2.6-2.6,2.6H3.9c-1.4,0-2.6-1.1-2.6-2.6V3.8c0-1.4,1.2-2.6,2.6-2.6h6.4V5c0,1.4,1.2,2.6,2.6,2.6h3.9 L16.7,19.2L16.7,19.2z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: fillColor,
    d: "M13,12.6L9.1,8.1l-3.9,4.4c-0.2,0.3-0.2,0.7,0.1,1 c0.3,0.2,0.7,0.2,1-0.1l2.2-2.5v5.3c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7v-5.3l2.2,2.5c0.1,0.2,0.3,0.2,0.5,0.2s0.3-0.1,0.4-0.2 C13.2,13.3,13.3,12.8,13,12.6z"
  }), /*#__PURE__*/React__default.createElement("g", {
    id: "Group-11-Copy-6",
    transform: "translate(9.173077, 18.673077) rotate(90.000000) translate(-9.173077, -18.673077) translate(7.673077, 13.173077)"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: fillColor,
    d: "M2.5,0.9v9.6c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7V0.9 c0-0.4,0.3-0.7,0.7-0.7S2.5,0.5,2.5,0.9z"
  })))));
};

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: ", ";\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var dropzoneContainerStyle = css(_templateObject$4(), function (props) {
  return props.theme.zIndex.heaven;
});
var dropzoneContainer;
var DropzonePortal = function DropzonePortal(_ref) {
  var children = _ref.children;

  if (!dropzoneContainer) {
    dropzoneContainer = document.createElement('div');
    dropzoneContainer.setAttribute('id', 'dropzone-container');
    dropzoneContainer.setAttribute('style', dropzoneContainerStyle.join(''));
  }

  useEffect(function () {
    document.body.appendChild(dropzoneContainer);
    return function () {
      document.body.removeChild(dropzoneContainer);
    };
  }, []);
  return ReactDOM.createPortal(children, dropzoneContainer);
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n    visibility: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHiddenFileInput = styled.input(_templateObject$5());
var HiddenFileInput = function HiddenFileInput(_a) {
  var onChange = _a.onChange,
      multiple = _a.multiple,
      inputRef = _a.inputRef,
      rest = __rest(_a, ["onChange", "multiple", "inputRef"]);

  var handleOnChange = function handleOnChange() {
    if (!inputRef) return;
    var files = inputRef.current.files;
    onChange(files);
  };

  return /*#__PURE__*/React__default.createElement(StyledHiddenFileInput, _extends({
    ref: inputRef,
    type: "file",
    multiple: multiple,
    onChange: handleOnChange
  }, rest));
};

var counter = 0;

var noPropagation = function noPropagation(evt) {
  evt.stopPropagation();

  if (evt.preventDefault) {
    return evt.preventDefault();
  }

  return evt.returnValue = false;
};

var useDropZone = function useDropZone() {
  var defaultShowDropzone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(defaultShowDropzone),
      _useState2 = _slicedToArray(_useState, 2),
      showDropzone = _useState2[0],
      toggleDropzone = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      files = _useState4[0],
      setFiles = _useState4[1];

  useEffect(function () {
    function handleDrop(evt) {
      noPropagation(evt);
      setFiles(evt.dataTransfer.files);
      toggleDropzone(false);
    }

    function handleDragEnter(evt) {
      noPropagation(evt);
      counter = counter + 1;
      toggleDropzone(true);
    }

    function handleDragLeave(evt) {
      noPropagation(evt);
      counter = counter - 1;

      if (counter === 0) {
        toggleDropzone(false);
      }
    }

    window.addEventListener('drop', handleDrop);
    window.addEventListener('dragenter', handleDragEnter);
    window.addEventListener('dragleave', handleDragLeave);
    window.addEventListener('dragstart', noPropagation);
    window.addEventListener('dragend', noPropagation);
    window.addEventListener('dragover', noPropagation);
    return function () {
      window.removeEventListener('drop', handleDrop);
      window.removeEventListener('dragenter', handleDragEnter);
      window.removeEventListener('dragleave', handleDragLeave);
      window.removeEventListener('dragstart', noPropagation);
      window.removeEventListener('dragend', noPropagation);
      window.removeEventListener('dragover', noPropagation);
    };
  }, []);
  return [showDropzone, files];
};

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    background-color: ", ";\n    border: 3px dashed ", ";\n    transition: ", ";\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var DropzoneOverlay = styled.div(_templateObject$6(), function (props) {
  return props.theme.colors.mercuryOpacity;
}, function (props) {
  return props.theme.colors.boulder;
}, function (props) {
  return props.theme.transition.all;
});
var DropzoneContent = styled.div(_templateObject2$3());

var sanitizeFileInput = function sanitizeFileInput(_ref) {
  var multiple = _ref.multiple,
      accept = _ref.accept;
  return {
    multiple: multiple
  };
};

var sanitizeButtonProps = function sanitizeButtonProps(_a) {
  var onChange = _a.onChange,
      multiple = _a.multiple,
      accept = _a.accept,
      onClick = _a.onClick,
      onShowSelect = _a.onShowSelect,
      rest = __rest(_a, ["onChange", "multiple", "accept", "onClick", "onShowSelect"]);

  return rest;
};

var validateAccept = function validateAccept(accept, files) {
  for (var _i = 0, _Object$values = Object.values(files); _i < _Object$values.length; _i++) {
    var file = _Object$values[_i];
    var isValid = accept.includes(file.type);

    if (!isValid) {
      return false;
    }
  }

  return true;
};

var FileButtonView = function FileButtonView(_a) {
  var id = _a.id,
      onChange = _a.onChange,
      onAcceptError = _a.onAcceptError,
      accept = _a.accept,
      _a$onShowSelect = _a.onShowSelect,
      onShowSelect = _a$onShowSelect === void 0 ? false : _a$onShowSelect,
      theme = _a.theme,
      rest = __rest(_a, ["id", "onChange", "onAcceptError", "accept", "onShowSelect", "theme"]);

  var _useDropZone = useDropZone(false),
      _useDropZone2 = _slicedToArray(_useDropZone, 2),
      showDropzone = _useDropZone2[0],
      droppedFiles = _useDropZone2[1];

  useEffect(function () {
    if (droppedFiles) {
      if (accept && onAcceptError) {
        var isValid = validateAccept(accept.split(','), droppedFiles);

        if (!isValid) {
          onAcceptError(new Error('Drop file(s) not valid'));
          return;
        }
      }

      handleOnChange(droppedFiles);
    } // Only watch dropped files otherwise `onChange` will be updated by parent
    // a do an infite loop

  }, [droppedFiles]); // eslint-disable-line react-hooks/exhaustive-deps

  var hiddenFileInputRef = useRef(null);

  var handleOnClick = function handleOnClick() {
    if (!hiddenFileInputRef) return;
    hiddenFileInputRef.current.click();
  };

  var handleOnChange = function handleOnChange(droppedFiles) {
    onChange(droppedFiles); // reset the value after, otherwise we cannot not select the same file twice
    // file input is no triggering onChange event for the same file(s)

    hiddenFileInputRef.current.value = '';
  }; // When onShowSelect is updated and NOT `false` it trigger handleClick.
  //  so we can call select file from outside


  useEffect(function () {
    if (onShowSelect !== false) {
      handleOnClick();
    }
  }, [onShowSelect]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(HiddenFileInput, _extends({
    id: id,
    inputRef: hiddenFileInputRef,
    onChange: handleOnChange,
    accept: accept
  }, sanitizeFileInput(rest))), /*#__PURE__*/React__default.createElement(Button, _extends({
    onClick: handleOnClick
  }, sanitizeButtonProps(rest))), showDropzone && /*#__PURE__*/React__default.createElement(DropzonePortal, null, /*#__PURE__*/React__default.createElement(DropzoneOverlay, null, /*#__PURE__*/React__default.createElement(DropzoneContent, null, /*#__PURE__*/React__default.createElement(DocumentUpload, {
    width: 55,
    height: 55,
    fillColor: theme.brand.primary
  }), /*#__PURE__*/React__default.createElement(Typograph, {
    pl: [3],
    fontSize: [5],
    color: theme.brand.primary,
    tx: "fileButton.dropzone"
  })))));
};
var FileButton = withTheme(FileButtonView);

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    display: flex;\n    height: ", "px;\n    width: ", "px;\n    padding: 0px;\n    border-radius: 100px;\n    text-align: center;\n    font-size: ", ";\n    color: ", ";\n    background: ", ";\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    ", ";\n    ", ";\n    ", ";\n    @media (max-width: ", ") {\n        height: ", "px;\n        width: ", "px;\n        font-size: ", ";\n    }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var StepIconContainer = styled(Box)(_templateObject$7(), function (props) {
  return props.theme.fonts.Montserrat700;
}, function (props) {
  return props.theme.space[5];
}, function (props) {
  return props.theme.space[5];
}, function (props) {
  return props.theme.fontSizes[3];
}, function (props) {
  return props.theme.brand.secondary;
}, function (props) {
  return props.theme.brand.accent;
}, space, width, height, function (props) {
  return props.theme.breakpoints[0];
}, function (props) {
  return props.theme.space[4];
}, function (props) {
  return props.theme.space[4];
}, function (props) {
  return props.theme.fontSizes[2];
});

var StepIcon = function StepIcon(_a) {
  var label = _a.label,
      props = __rest(_a, ["label"]);

  return /*#__PURE__*/createElement(StepIconContainer, _extends({}, props, {
    "data-test-id": "step_icon_container"
  }), label);
};

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n    display: grid;\n    flex-direction: column;\n    align-content: flex-end;\n    align-items: flex-end;\n    margin-right: 6px;\n    cursor: ", ";\n    width: ", "%;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    font-size: ", ";\n    color: ", ";\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var StepLine = styled.div(_templateObject$8(), function (_ref) {
  var theme = _ref.theme,
      done = _ref.done;
  return done ? "height: 5px;\n    background-color: ".concat(theme.brand.accent) : "height: 4px;\n    background-color: ".concat(theme.backgroundColor.disabled);
});
var StepTitle = styled.div(_templateObject2$4(), function (props) {
  return props.theme.fontSizes[1];
}, function (props) {
  return props.theme.colors.boulder;
});
var StepWrapper = styled.div(_templateObject3$1(), function (_ref2) {
  var done = _ref2.done,
      enableClick = _ref2.enableClick;
  return done && enableClick ? 'pointer' : 'normal';
}, function (_ref3) {
  var widthLine = _ref3.widthLine;
  return widthLine;
});

var DesktopBar = function DesktopBar(_a) {
  var currentStepId = _a.currentStepId,
      numOfSteps = _a.numOfSteps,
      updateStep = _a.updateStep,
      currentStep = _a.currentStep,
      _a$enableClick = _a.enableClick,
      enableClick = _a$enableClick === void 0 ? true : _a$enableClick,
      id = _a.id,
      props = __rest(_a, ["currentStepId", "numOfSteps", "updateStep", "currentStep", "enableClick", "id"]);

  return /*#__PURE__*/React__default.createElement(Flex, _extends({
    mb: "-1px",
    px: "20px",
    width: "100%"
  }, props, {
    "data-test-id": "progress_bar_".concat(id)
  }), times(function (n) {
    var isDone = currentStep >= n;
    var isCurrentStep = currentStep === n;
    return /*#__PURE__*/React__default.createElement(StepWrapper, {
      "data-test-id": "progress_bar_step_wrapper_".concat(n, "_").concat(id),
      key: "step-".concat(n),
      done: isDone,
      enableClick: enableClick,
      onClick: function onClick() {
        return enableClick && updateStep("".concat(isDone ? n : currentStep));
      },
      widthLine: 100 / numOfSteps
    }, isCurrentStep && /*#__PURE__*/React__default.createElement(StepTitle, {
      "data-test-id": "progress_bar_step_title_".concat(n, "_").concat(id)
    }, "".concat(currentStepId, "/").concat(numOfSteps)), /*#__PURE__*/React__default.createElement(StepLine, {
      "data-test-id": "progress_bar_step_line_".concat(n, "_").concat(id),
      done: isDone
    }));
  }, numOfSteps));
};

var ProgressBar = function ProgressBar(_a) {
  var _a$id = _a.id,
      id = _a$id === void 0 ? 'default' : _a$id,
      currentStepId = _a.currentStepId,
      numOfSteps = _a.numOfSteps,
      updateStep = _a.updateStep,
      props = __rest(_a, ["id", "currentStepId", "numOfSteps", "updateStep"]);

  var currentStep = currentStepId - 1;
  return /*#__PURE__*/createElement(DesktopBar, _extends({
    currentStepId: currentStepId,
    numOfSteps: numOfSteps,
    currentStep: currentStep,
    id: id,
    updateStep: updateStep
  }, props));
};

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    margin: 0;\n    transform: translateY(50%);\n    justify-content: flex-end;\n    align-items: flex-end;\n\n    @media (max-width: ", ") {\n        ", ";\n        flex-direction: column;\n        align-items: stretch;\n\n        > * {\n            margin: ", "px 0;\n        }\n    }\n\n    margin-top: ", "px;\n\n    ", ";\n    ", ";\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var Actions = styled(Flex)(_templateObject$9(), function (props) {
  return props.theme.breakpoints[0];
}, function (props) {
  return props.bothActions && "transform: translateY(25%);";
}, function (props) {
  return props.theme.space[1];
}, function (props) {
  return props.theme.space[1];
}, space, width);

var hasMoreThanOneAction = function hasMoreThanOneAction(children) {
  var _a;

  var isFragment$1 = isFragment(children);

  if (isFragment$1) {
    if (((_a = children.props) === null || _a === void 0 ? void 0 : _a.children) && Array.isArray(children.props.children) && children.props.children.length >= 2) {
      return true;
    }

    return false;
  }

  if (children && Array.isArray(children) && children.length >= 2) {
    return true;
  }

  return false;
};

var CardActions = function CardActions(_a) {
  var id = _a.id,
      children = _a.children,
      props = __rest(_a, ["id", "children"]);

  return /*#__PURE__*/createElement(Actions, _extends({
    "data-test-id": "cardActions_".concat(id || ''),
    width: "100%",
    position: ['relative', 'absolute'],
    bothActions: hasMoreThanOneAction(children)
  }, props), children);
};

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    transition: box-shadow ", ";\n\n    border-radius: ", ";\n\n    font-family: ", ";\n    font-size: ", ";\n\n    &:hover {\n        ", ";\n    }\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var StyledCardContainer = styled(Box)(_templateObject$a(), function (props) {
  return props.theme.transitionAnimation;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontSizes[1];
}, shadow, space, height, width, border, borderColor, shadow);

var CardContainerView = function CardContainerView(_a) {
  var id = _a.id,
      children = _a.children,
      bg = _a.bg,
      theme = _a.theme,
      props = __rest(_a, ["id", "children", "bg", "theme"]);

  return /*#__PURE__*/createElement(StyledCardContainer, _extends({
    "data-test-id": "cardComponent_".concat(id),
    bg: bg ? bg : theme.brand.secondary
  }, props), children);
};

var CardContainer = withTheme(CardContainerView);

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n            ", "px\n        "]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n    padding: ", ";\n\n    ", "\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var StyledCardContainer$1 = styled(CardContainer)(_templateObject$b(), function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$5(), theme.space[4]);
}, space);

var CardView = function CardView(_a) {
  var id = _a.id,
      children = _a.children,
      actions = _a.actions,
      actionProps = _a.actionProps,
      pb = _a.pb,
      theme = _a.theme,
      props = __rest(_a, ["id", "children", "actions", "actionProps", "pb", "theme"]);

  return /*#__PURE__*/createElement(StyledCardContainer$1, _extends({
    id: id
  }, props, {
    pb: !pb && actions ? [0] : pb
  }), children, actions && /*#__PURE__*/createElement(CardActions, _extends({
    id: id
  }, actionProps), actions));
};

var Card = withTheme(CardView);

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var CardInnerTitle = styled(Typograph)(_templateObject$c(), function (props) {
  return props.theme.fonts.Montserrat700;
});

var CardWithLabelView = function CardWithLabelView(_a) {
  var id = _a.id,
      children = _a.children,
      label = _a.label,
      fontSize = _a.fontSize,
      theme = _a.theme,
      props = __rest(_a, ["id", "children", "label", "fontSize", "theme"]);

  return /*#__PURE__*/createElement(Card, _extends({
    id: id
  }, props), label && /*#__PURE__*/createElement(CardInnerTitle, {
    "data-test-id": "cardLabel_".concat(id),
    tx: label,
    fontSize: fontSize ? fontSize : theme.fontSizes[3],
    mt: 0,
    mb: 3
  }), children);
};

var CardWithLabel = withTheme(CardWithLabelView);

var CardWizardView = function CardWizardView(_a) {
  var children = _a.children,
      width = _a.width,
      theme = _a.theme,
      props = __rest(_a, ["children", "width", "theme"]);

  return /*#__PURE__*/createElement(CardWithLabel, _extends({
    width: width || theme.contentWidths
  }, props), children);
};

var CardWizard = withTheme(CardWizardView);

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    ", ";\n    ", "\n    width: calc(100% - ", "px);\n    text-align: center;\n    border-radius: ", ";\n    color: ", ";\n    margin-top: -", "px;\n    padding-top: ", "px;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    ", ";\n    ", "\n    width: inherit;\n    text-align: center;\n    height: 4em;\n    border-radius: ", ";\n    color: ", ";\n    margin-bottom: -", "px;\n    padding-bottom: ", "px;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    min-height: ", "px;\n    padding: ", "px;\n    ", ";\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n    z-index: 2;\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var CardContainerStyled = styled(CardContainer)(_templateObject$d());
var CardContent = styled(Box)(_templateObject2$6(), function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.space[6];
}, function (props) {
  return props.theme.space[4];
}, space);
var CardTitle = styled(Flex)(_templateObject3$2(), function (props) {
  return props.theme.fontFamily;
}, fontWeight, fontSize, function (props) {
  return props.theme.borderRadiusTitle;
}, function (props) {
  return props.theme.brand.secondary;
}, function (props) {
  return props.theme.space[2];
}, function (props) {
  return props.theme.space[2];
});
var CardFooter = styled(Flex)(_templateObject4$1(), function (props) {
  return props.theme.fontFamily;
}, fontWeight, fontSize, function (props) {
  return props.theme.borderWidth;
}, function (props) {
  return props.theme.borderRadiusTitle;
}, function (props) {
  return props.theme.brand.secondary;
}, function (props) {
  return props.theme.space[2];
}, function (props) {
  return props.theme.space[2];
});

var CardWithTitleView = function CardWithTitleView(_a) {
  var id = _a.id,
      children = _a.children,
      title = _a.title,
      p = _a.p,
      pt = _a.pt,
      pr = _a.pr,
      pb = _a.pb,
      pl = _a.pl,
      py = _a.py,
      px = _a.px,
      bg = _a.bg,
      titleBackground = _a.titleBackground,
      footerBackground = _a.footerBackground,
      footer = _a.footer,
      theme = _a.theme,
      containerProps = _a.containerProps,
      props = __rest(_a, ["id", "children", "title", "p", "pt", "pr", "pb", "pl", "py", "px", "bg", "titleBackground", "footerBackground", "footer", "theme", "containerProps"]);

  return /*#__PURE__*/createElement(Flex, _extends({
    flexDirection: "column",
    alignItems: "center"
  }, containerProps), /*#__PURE__*/createElement(CardContainerStyled, _extends({
    id: id,
    border: theme.borderCard,
    borderColor: titleBackground ? titleBackground : theme.brand.accent,
    width: "100%"
  }, props), /*#__PURE__*/createElement(CardTitle, {
    "data-test-id": "cardTitle_".concat(id),
    fontSize: ['14px', '16px', '16px'],
    fontWeight: 700,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: titleBackground ? titleBackground : theme.brand.accent
  }, /*#__PURE__*/createElement(Typograph, {
    tx: title
  })), /*#__PURE__*/createElement(CardContent, {
    p: p,
    py: py,
    px: px,
    pt: pt,
    pr: pr,
    pb: pb,
    pl: pl,
    bg: bg ? bg : theme.brand.secondary
  }, children)), footer && /*#__PURE__*/createElement(CardFooter, {
    "data-test-id": "cardFooter_".concat(id),
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: footerBackground ? footerBackground : theme.brand.tertiary
  }, footer));
};

var CardWithTitle = withTheme(CardWithTitleView);

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    background: ", ";\n    border-color: ", ";\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    border: 1px solid ", ";\n    width: 100%;\n    margin-bottom: -", "px;\n    min-height: ", "px;\n    box-shadow: ", ";\n\n    ", ";\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var StyledStackElement = styled(Flex)(_templateObject$e(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.seashell;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.colors.seashell;
}, function (props) {
  return props.theme.space[1];
}, function (props) {
  return props.theme.space[3];
}, function (props) {
  return props.theme.stackBoxShadow;
}, borderColor);
var Stacker = function Stacker(_a) {
  var id = _a.id,
      stack = _a.stack,
      children = _a.children,
      styledProps = __rest(_a, ["id", "stack", "children"]);

  return stack && stack.map(function (item, index) {
    return /*#__PURE__*/createElement(StyledStackElement, _extends({
      key: item.id,
      width: "100%",
      id: "cardStack_".concat(id, "_").concat(index),
      mb: "-7px",
      onClick: item.onClick
    }, styledProps), children(item, id, index));
  });
};

export { Button, Card, CardActions, CardContainer, CardWithLabel, CardWithTitle, CardWizard, DocumentUpload, FileButton, FileButtonView, GroupButton, GroupButtonView, ProgressBar, RadioButton, RadioButtonChecked, RadioButtonIcon, RightArrow, Stacker, StepIcon, StyledStackElement, SubmitButton, Typograph, UnstyledButton, checkIfTxIncludesTags };
